import { Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

const R = Resources.Inspiration.OwnHome.Result;

type Props = {
	bg: string;
	icon: ReactNode;
	iconBg: string;
	tag: string;
	tagColor: string;
	totalValue: string;
	dividerColor: string;
	endLabel: string;
	endValue: ReactNode;
};

export const ComparisonColumn: FC<Props> = ({
	bg,
	icon,
	iconBg,
	tag,
	tagColor,
	totalValue,
	dividerColor,
	endLabel,
	endValue,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Stack
			flex={1}
			bgcolor={bg}
			borderRadius={theme.radii.lg}
			p={1.2}
			alignItems="center"
		>
			<IconBox bg={iconBg} size={32}>
				{icon}
			</IconBox>
			<Typography
				variant="button"
				color={tagColor}
				mt={0.8}
				textTransform="uppercase"
			>
				{tag}
			</Typography>
			<Typography variant="hint" color={theme.palette.grey[500]} mt={0.4}>
				{t(R.comparisonTotalLabel)}
			</Typography>
			<Typography
				mt={0.4}
				fontSize="14px"
				fontWeight={700}
				color={theme.palette.grey[900]}
				tabular
			>
				{totalValue}
			</Typography>
			<Stack
				width="100%"
				alignItems="center"
				gap={0.2}
				mt={0.8}
				pt={0.8}
				borderTop={theme.colors.border.solid(dividerColor)}
			>
				<Typography variant="hint" color={theme.palette.grey[500]}>
					{endLabel}
				</Typography>
				{endValue}
			</Stack>
		</Stack>
	);
};
